export const NO_IMAGE_ID = "none";

export const CS3D_DESIGNATOR = "99CS3D";

export const TEXT_ANNOTATION_POSITION = {
    schemeDesignator: CS3D_DESIGNATOR,
    meaning: "Text Annotation Position",
    value: "TextPosition"
};

export const COMMENT_CODE = {
    schemeDesignator: "DCM",
    meaning: "Comment",
    value: "121106"
};
